import './StoreGroupPage.less';

export const prefix = 'bm-p-store-group';

export { default } from './StoreGroupPage';
